export const useHeaderTabs = t => ({
  DASHBOARD: t('header.tab_1'),
  JOBS: t('header.tab_2'),
  CANDIDATES: t('header.tab_3'),
  ANALYTICS: t('header.tab_4'),
});
